import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { SourcesProps } from '../src/components/Sources.ts';

export const SourcesList: LoadableType<SourcesProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsSourcesList" */ '../src/components/SourcesList.tsx'
			)
		).SourcesList,
});
